/** ISO alpha-3 country codes for the most used countries */
export const USA_ISO_CODE = 'USA';
export const CANADA_ISO_CODE = 'CAN';
export const AUSTRALIA_ISO_CODE = 'AUS';
export const UNITED_KINGDOM_ISO_CODE = 'GBR';
export const IRELAND_ISO_CODE = 'IRL';
export const NEW_ZEALAND_ISO_CODE = 'NZL';
export const AUSTRIA_ISO_CODE = 'AUT';
export const BELGIUM_ISO_CODE = 'BEL';
export const FRANCE_ISO_CODE = 'FRA';
export const GERMANY_ISO_CODE = 'DEU';
export const GREECE_ISO_CODE = 'GRC';
export const ITALY_ISO_CODE = 'ITA';
export const NETHERLANDS_ISO_CODE = 'NLD';
export const PORTUGAL_ISO_CODE = 'PRT';
export const SINGAPORE_ISO_CODE = 'SGP';
export const SOUTH_AFRICA_ISO_CODE = 'ZAF';
export const SPAIN_ISO_CODE = 'ESP';
export const SWEDEN_ISO_CODE = 'SWE';
export const SWITZERLAND_ISO_CODE = 'CHE';
export const TAIWAN_ISO_CODE = 'TWN';
export const TURKEY_ISO_CODE = 'TUR';
export const PHILIPPINES_ISO_CODE = 'PHL';
export const MACAU_ISO_CODE = 'MAC';
export const HONG_KONG_ISO_CODE = 'HKG';

/** ISO alpha-3 country codes for excluded countries */
export const RUSSIA_ISO_CODE = 'RUS';
export const BELARUS_ISO_CODE = 'BLR';
